import { DiContainerInjectFn } from "../di/ts";
import { SearchService } from "./services/root.service";

export default ((container) => {
    container.bind(SearchService).to(SearchService).inSingletonScope();
  }) as DiContainerInjectFn;